'use client';

import { PinnedPanelsVariant } from 'components/fall-2026/modules/CardsVerticalScroll/PinnedPanelsVariant';
import { useEffect, useState } from 'react';
import { useBreakpoint } from 'hooks/useBreakpoints';
import { CardsVerticalScrollProps } from './types';
import CardsVerticalScrollDesktop from './CardsVerticalScrollDesktop';
import CardsVerticalScrollMobile from './CardsVerticalScrollMobile';

const DefaultCardsVerticalScroll = (props: CardsVerticalScrollProps) => {
  const [isMounted, setIsMounted] = useState(false);
  // oxlint-disable-next-line react/set-state-in-effect -- hydration check, only runs once on mount
  useEffect(() => setIsMounted(true), []);

  const { isAboveMd } = useBreakpoint('md');
  const isDesktop = isMounted ? isAboveMd : false;

  return <>{isDesktop ? <CardsVerticalScrollDesktop {...props} /> : <CardsVerticalScrollMobile {...props} />}</>;
};

const CardsVerticalScroll = (props: CardsVerticalScrollProps) =>
  props.variant === 'Fall 2026' ? <PinnedPanelsVariant {...props} /> : <DefaultCardsVerticalScroll {...props} />;

export default CardsVerticalScroll;
